import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { WorkshopCardboardStoreEffects } from './effects';
import { reducer } from './reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('workshop-cardboard', reducer),
    EffectsModule.forFeature([WorkshopCardboardStoreEffects]),
  ],
  providers: [],
})
export class WorkshopCardboardStoreModule {}
